import TextField from '@mui/material/TextField';
import control from '../../utils/inputControl'

export default function Input({label,variant,size,value,setValue, helperText,multiline,rows, type, maxLength,color,onKeyDownFunction,error}) {

    const handleChange = (e) => {
        const inputValue = e.target.value
        const setStatus = setValue
        const max = maxLength
        switch (type) {
            case 'number':
                control.number({value:inputValue,setStatus,max})
                break;
            default:
                control.text({value:inputValue,setStatus,max})
                break;
        }
    }

      // Ejecuto alguna funcion al presionar enter
  const handleEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      onKeyDownFunction();
    }
  };

  return (
      <TextField
      error={error || false}
      fullWidth
      onKeyDown={onKeyDownFunction && handleEnterKeyPress}
      color={color || 'primary'}
      id={label || 'id'}
      multiline = {multiline || false}
      rows={rows || 1}
      label={label || "Outlined"} 
      variant={variant || "outlined"} 
      size={size || 'medium'} value={value} 
      onChange={e =>handleChange(e)} helperText={helperText || ''} 
      />
  );
}
